import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface RadialProgressBarCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapper():object;
    getPieDivCSSStyle():object;
    
}

export class RadialProgressBarCSSStyleImpl extends UIComponentCSSStyleImpl implements RadialProgressBarCSSStyle
{

    getWrapperCSSStyle():object
    {
        return{
            display: "block",
            margin:"0px auto",
            color: "#1ABC9C",
            fontSize: "20px",
            textAlign:'center'
        };
    }

    getInnerWrapper():object
    {
        return{
            fontSize: '54px',
        };
    }

    getPieDivCSSStyle():object
    {
        return{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
        };
    }

  
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/radialprogressbar/radialprogressbarcss.tsx